<script setup>
import { defineModel } from 'vue';
import UploadDateRangeFields from '@/components/CreateConnectionComponents/UploadDateRangeFields.vue';

const dateField = defineModel('dateField', { default: 'DATE_CREATE' });
const startDate = defineModel('startDate');
const endDate = defineModel('endDate');

const dateFieldOptions = [
    {
        value: 'DATE_CREATE',
        label: 'Дата создания',
        description: 'Фильтровать контакты по дате создания',
    },
    {
        value: 'DATE_MODIFY',
        label: 'Дата обновления',
        description: 'Фильтровать контакты по дате изменения',
    },
];
</script>

<template>
    <div class="w-full flex flex-col gap-6 px-6 pb-10">
        <div>
            <div class="text-base sm:text-lg font-bold text-gray-800 mb-3">
                Контакты
            </div>
            <p class="text-sm text-gray-500">
                Выберите, по какому полю даты фильтровать контакты, и укажите период.
            </p>
        </div>

        <div>
            <div class="text-sm font-medium text-gray-700 mb-3">
                Фильтровать по
            </div>
            <div class="flex flex-col sm:flex-row gap-3">
                <button
                    v-for="option in dateFieldOptions"
                    :key="option.value"
                    type="button"
                    class="flex-1 px-4 py-3 rounded-md border-2 text-left transition-colors duration-150"
                    :class="dateField === option.value
                        ? 'border-blue-500 bg-blue-50 text-blue-700'
                        : 'border-blue-200 text-gray-700 hover:bg-blue-50/60'"
                    @click="dateField = option.value"
                >
                    <div class="text-sm font-semibold">
                        {{ option.label }}
                    </div>
                    <div class="text-xs mt-1 opacity-80">
                        {{ option.description }}
                    </div>
                </button>
            </div>
        </div>

        <UploadDateRangeFields
            v-model:start-date="startDate"
            v-model:end-date="endDate"
            title="Период фильтрации"
            id-prefix="bitrix-contacts"
        />
    </div>
</template>
